export default __webpack_public_path__ + "static/media/background_star.377e574f.png";